import { render, staticRenderFns } from "./Kubernetes.vue?vue&type=template&id=c5367eb0&scoped=true"
import script from "./Kubernetes.vue?vue&type=script&lang=js"
export * from "./Kubernetes.vue?vue&type=script&lang=js"
import style0 from "./Kubernetes.vue?vue&type=style&index=0&id=c5367eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5367eb0",
  null
  
)

export default component.exports